const translations = {
    en: {
        hero1: "Simple Fun for Everyone!",
        hero2: "Casual Games & Gamified Apps",



        navLink1: "Home",
        navLink2: "About us",
        navLink3: "Services",
        navLink4: "Contact",



        aboutUs1: "ABOUT",
        aboutUs2: "We're a small game development studio based in Slovenia <img src='https://flagcdn.com/si.svg' alt='SL' width='30' height='30' />, creating simple, fun, and engaging games and gamified apps.Our focus is on turning ideas into playful digital experiences that capture attention and spark enjoyment.",



        WhatWeDo1: "Turning ideas into playful worlds your users will love to explore.",

        wwd1: "Interactive Game Development",
        wwd2: "We design and develop fully custom games that are built to engage and entertain. Whether you need a fun interactive project for your brand, a training tool for teams or a learning experience for students.",

        wwd3: "Promotional & Branded Games",
        wwd4: "We design games that showcase your brand in a memorable and interactive way. Each experience is tailored to highlight your products, services, or campaigns while keeping players engaged. We turn entertainment into a powerful tool for connecting with your audience.",

        wwd5: "Gamified App Development",
        wwd6: "We design and build fully custom apps with game-like elements that make learning, training, or engagement fun and rewarding. Your goals, audience, and content shape an interactive experience that users actually want to use.",



        OurProcessTitle: "Our Development Process",

        OurProcess1: "<strong>Discovery & Planning</strong> - We discuss your idea, audience, goals, required features, preferred art style, and platform. We provide a rough estimate and propose solutions.",

        OurProcess2: "<strong>Concept & Prototype</strong> - We create a basic playable or visual prototype to confirm core mechanics, UX flow, or educational/game objectives before full production begins.",

        OurProcess3: "<strong>Full Development</strong> - We build the complete experience: gameplay systems, levels, UI, art, sound, and logic using the Godot engine.",

        OurProcess4: "<strong>Testing & Feedback</strong> - You test the build, provide feedback, and we refine the experience. We ensure performance, polish, and usability.",

        OurProcess5: "<strong>Delivery & Post-Launch Support</strong> - Final delivery of the game/app, plus optional updates, maintenance, or future expansion if needed.",



        OurProjectsTitle: "OUR PROJECTS",
        OP_sushisplash: "Catch flying fish before they escape - and don't fall off the boat!",
        OP_spacepowerup: "Blast space rubble from the cockpit and feel like a real pilot.",
        OP_wreckbounce: "Classic brick-breaking fun - but made extra friendly and bouncy.",
        OP_kiddypuzzle: "Drag and match - simple touchscreen puzzle fun for little kids.",
        OP_claudeoculos: "A haunting game of sound and silence - escape the blind rabbit before it finds you.",
        OP_rogueskingdom:"Build, battle, and rule your way through a kingdom that never stays the same.",
        OP_summonerstrials:"Call forth mighty creatures and outsmart chaos in this fast-paced summoning roguelike.",
        OP_thewitchesbox:"A knight, a cursed room, and a witch who won't play fair - how long can you survive?",
        OP_beanboybouncin:"Bounce, blast, and boing your way through chaos as the unstoppable Bean Boy!",


        gamedemo_h:"TRY A DEMO 🚀",
        gamedemo_p:"Try a quick demo and get a feel for what a custom-made promotional game could be.",


        ourClients: "OUR CLIENTS",



        contactTitle: "Have a game or app idea you'd like to bring to life?",
        contactText: "We turn your ideas into fully working interactive experiences - whether it's for education, training, events, or promotion. Just share your concept, goal, or even a rough sketch, and we'll help design, build, and polish a custom game or app that fits your audience perfectly. No need for technical knowledge - we handle the entire process from start to finish.",
        contactUsButton: "CONTACT US!",


        footerPrivacy: "Privacy Policy",
        footerContact: "Contact",


        privacyTitle: "Privacy Policy",
        privacyMain: `
            <p><strong>Last Updated:</strong> October 31, 2025</p>

            <h2>Data Controller:</h2>
            <p>Igralis Žan Mišič s.p.<br />
              Email: <a style={{ color: "black" }} href="mailto:contact@igralis.com">contact@igralis.com</a></p>

            <p>I am the data controller for this website.</p>

            <h2>1. What Data I Collect</h2>
            <p>I only collect personal data you provide voluntarily via:</p>
            <ul>
              <li>Contact form</li>
              <li>Email</li>
            </ul>
            <p>This may include: your name, email, company name and message content.</p>

            <h2>2. Purpose & Legal Basis</h2>
            <p>I process your data <strong>solely to respond to inquiries or discuss potential projects</strong>.<br />
              The legal bases for processing are:</p>
            <ul>
              <li><strong>Legitimate interest</strong> - responding to your inquiry</li>
              <li><strong>Necessity for contract</strong> - discussing or providing services</li>
            </ul>

            <h2>3. Data Retention</h2>
            <p>I retain your personal data for as long as there is a legitimate business need to communicate or potentially
              collaborate with you, unless you request its deletion. I may also retain data as required to comply with
              legal obligations (e.g., accounting/tax laws).</p>

            <h2>4. Sharing</h2>
            <p>Your data is <strong>never sold or shared</strong> with third parties.</p>

            <h2>5. Your Rights under GDPR & ZVOP-2</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access, correct, or delete your personal data</li>
              <li>Object to or restrict processing</li>
              <li>Request data portability</li>
            </ul>
            <p>To exercise these rights, email me at <a style={{ color: "black" }} href="mailto:contact@igralis.com">contact@igralis.com</a>.</p>
`,
    },
    sl: {
        hero1: "Preprosta zabava za vsakogar!",
        hero2: "Priložnostne igre in igraficirane aplikacije",



        navLink1: "Domov",
        navLink2: "O nas",
        navLink3: "Storitve",
        navLink4: "Kontakt",



        aboutUs1: "O NAS",
        aboutUs2: "Smo majhen studio za razvoj iger s sedežem v Sloveniji <img src='https://flagcdn.com/si.svg' alt='SL' width='30' height='30' />, ki ustvarja preproste, zabavne in privlačne igre ter igraficirane aplikacije. Naš poudarek je na spreminjanju idej v igrive digitalne izkušnje, ki pritegnejo pozornost in vzbujajo užitek.",



        WhatWeDo1: "Spreminjamo ideje v igrive svetove, ki jih bodo vaši uporabniki z veseljem raziskovali.",

        wwd1: "Razvoj interaktivnih iger",
        wwd2: "Oblikujemo in razvijamo popolnoma prilagojene igre, zasnovane za zabavo, vključenost in nepozabno izkušnjo. Ne glede na to, ali potrebujete zabaven interaktivni projekt za svojo blagovno znamko, orodje za usposabljanje ekip ali učno izkušnjo za študente.",

        wwd3: "Promocijske igre in igre po meri",
        wwd4: "Ustvarjamo igre po meri, ki na interaktiven in privlačen način predstavijo vašo blagovno znamko. Vsaka izkušnja je prilagojena vašim ciljem in zasnovana tako, da vzbudi zanimanje in poveča vključenost uporabnikov.",

        wwd5: "Razvoj igraficiranih aplikacij",
        wwd6: "Oblikujemo in gradimo popolnoma prilagojene aplikacije z elementi igre, ki učenje, usposabljanje ali sodelovanje naredijo zabavno in koristno. Vaši cilji, občinstvo in vsebina oblikujejo interaktivno izkušnjo, ki jo uporabniki dejansko želijo uporabljati.",



        OurProcessTitle: "Naš razvojni proces",

        OurProcess1: "<strong>Odkrivanje in načrtovanje</strong> - Pogovorimo se o vaši ideji, občinstvu, ciljih, zahtevanih funkcijah, želenem umetniškem slogu in platformi. Zagotovimo grobo oceno in predlagamo rešitve.",

        OurProcess2: "<strong>Koncept in prototip</strong> - Pred začetkom polne produkcije ustvarimo osnovni igralni ali vizualni prototip, da potrdimo ključne mehanike, potek uporabniške izkušnje ali izobraževalne/igralne cilje.",

        OurProcess3: "<strong>Celoten razvoj</strong> - Z uporabo igralnega pogona Godot zgradimo celotno izkušnjo: igralne sisteme, nivoje, uporabniški vmesnik, grafiko, zvok in logiko.",

        OurProcess4: "<strong>Testiranje in povratne informacije</strong> - Vi preizkusite gradnjo, posredujete povratne informacije, mi pa izboljšamo izkušnjo. Zagotavljamo delovanje, dodelavo in uporabnost.",

        OurProcess5: "<strong>Dostava in podpora po izdaji</strong> - Končna dostava igre/aplikacije, vključno z neobveznimi posodobitvami, vzdrževanjem ali morebitnimi prihodnjimi razširitvami.",



        OurProjectsTitle: "NAŠI PROJEKTI",
        OP_sushisplash: "Ujemite leteče ribe, preden pobegnejo - pazite, da ne padete iz čolna!",
        OP_spacepowerup: "Razstreli vesoljske ruševine iz pilotske kabine in se počuti kot pravi pilot.",
        OP_wreckbounce: "Klasična zabava z razbijanjem opek - vendar še bolj prijazna in poskakujoča.",
        OP_kiddypuzzle: "Povlecite in povežite - preprosta zabavna uganka na dotik za najmlajše.",
        OP_claudeoculos: "Grozeča igra zvoka in tišine - pobegni slepemu zajcu, preden te najde.",
        OP_rogueskingdom:"Zgradi, osvoji in zavladaj kraljestvu, ki se nikoli ne ponovi.",
        OP_summonerstrials:"Prikliči mogočna bitja in premagaj kaos v hitrem roguelike izzivu.",
        OP_thewitchesbox:"Vitez, prekleta soba in čarovnica brez usmiljenja - koliko časa boš zdržal?",
        OP_beanboybouncin:"Skači, streljaj in se odbijaj skozi kaos kot neustavljivi Bean Boy!",

        gamedemo_h:"PREIZKUSITE DEMO🚀",
        gamedemo_p:"Preizkusite kratko demo različico in začutite, kako bi lahko izgledala po meri izdelana promocijska igra.",


        ourClients: "NAŠE STRANKE",



        contactTitle: "Imate idejo za igro ali aplikacijo, ki bi jo radi uresničili?",
        contactText: "Vaše ideje spremenimo v popolnoma delujoče interaktivne izkušnje - pa naj gre za izobraževanje, usposabljanje, dogodke ali promocijo. Preprosto delite svoj koncept, cilj ali celo grobo skico in pomagali vam bomo oblikovati, zgraditi in izpiliti igro ali aplikacijo po meri, ki bo popolnoma ustrezala vašim uporabnikom. Ni potrebno tehnično znanje - mi poskrbimo za celoten proces od začetka do konca.",
        contactUsButton: "KONTAKTIRAJTE NAS!",



        footerPrivacy: "Politika zasebnosti",
        footerContact: "Kontakt",


        privacyTitle: "Politika zasebnosti",
        privacyMain: `
            <p><strong>Zadnja posodobitev:</strong> 31. oktober 2025</p>

            <h2>Upravljavec podatkov:</h2>
            <p>Igralis Žan Mišič s.p.<br />
            E-pošta: <a style={{ color: "black" }} href="mailto:contact@igralis.com">contact@igralis.com</a></p>

            <p>Sem upravljavec podatkov za to spletno mesto.</p>

            <h2>1. Katere podatke zbiram</h2>
            <p>Zbiram samo osebne podatke, ki jih prostovoljno posredujete prek:</p>
            <ul>
            <li>Kontaktnega obrazca</li>
            <li>E-pošte</li>
            </ul>
            <p>To lahko vključuje: vaše ime, e-pošto, ime podjetja in vsebino sporočila.</p>

            <h2>2. Namen in pravna podlaga</h2>
            <p>Vaše podatke obdelujem <strong>izključno za odgovor na povpraševanje ali razpravo o morebitnih projektih</strong>.<br />
            Pravne podlage za obdelavo so:</p>
            <ul>
            <li><strong>Zakonit interes</strong> - odgovor na vaše povpraševanje</li>
            <li><strong>Potreba za pogodbo</strong> - razprava o storitvah ali njihovo zagotavljanje</li>
            </ul>

            <h2>3. Hramba podatkov</h2>
            <p>Vaše osebne podatke hranim, dokler obstaja legitimna poslovna potreba za komunikacijo ali morebitno sodelovanje z vami, razen če zahtevate njihov izbris. Podatke lahko hranim tudi, če je to potrebno za izpolnjevanje zakonskih obveznosti (npr. računovodska/davčna zakonodaja).</p>

            <h2>4. Deljenje</h2>
            <p>Vaši podatki <strong>nikoli ne bodo prodani ali deljeni</strong> s tretjimi osebami.</p>

            <h2>5. Vaše pravice v skladu z GDPR in ZVOP-2</h2>
            <p>Imate pravico do:</p>
            <ul>
            <li>Dostopa do svojih osebnih podatkov, njihovega popravka ali izbrisa</li>
            <li>Ugovora zoper obdelavo ali njene omejitve</li>
            <li>Zahteve za prenosljivost podatkov</li>
            </ul>
            <p>Za uveljavljanje teh pravic mi pišite na <a style={{ color: "black" }} href="mailto:contact@igralis.com">contact@igralis.com</a>.</p>`,
    }
};

export function setLanguage(lang) {
    document.querySelectorAll("[data-translate]").forEach(el => {
        const key = el.getAttribute("data-translate");
        // el.textContent = translations[lang][key];
        el.innerHTML = translations[lang][key];

    });
}